import { render, staticRenderFns } from "./Table10.vue?vue&type=template&id=58b73f22&scoped=true&"
import script from "./Table10.vue?vue&type=script&lang=js&"
export * from "./Table10.vue?vue&type=script&lang=js&"
import style0 from "./Table10.vue?vue&type=style&index=0&id=58b73f22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b73f22",
  null
  
)

export default component.exports